export default __webpack_public_path__ + "static/characters_06_ShotzyPierce0-851c43dc919d344f513422da6ac257bd.png";